import { gql } from 'apollo-angular'

import { AUTHOR_BASIC_FIELDS } from './author.fragments'

/**
 * Basic article fields fragment Contains essential fields needed for displaying
 * article information
 */
export const ARTICLE_BASIC_FIELDS = gql`
  fragment ArticleBasicFields on Article {
    id
    slug
    title
    content
    published_at
    udh_id
    article_type
    groupedUsers {
      key
      authors {
        ...AuthorBasicFields
      }
    }
  }
`

/**
 * Standard article fields with authors Includes basic fields and authors with
 * minimal info
 */
export const ARTICLE_WITH_AUTHORS_FIELDS = gql`
  ${ARTICLE_BASIC_FIELDS}
  ${AUTHOR_BASIC_FIELDS}
  fragment ArticleWithAuthorsFields on Article {
    ...ArticleBasicFields
    users {
      authors {
        ...AuthorBasicFields
      }
    }
  }
`

/**
 * Article reference fields for magazines and editions Contains essential fields
 * for magazine and edition references
 */
export const ARTICLE_REFERENCE_FIELDS = gql`
  fragment ArticleReferenceFields on Article {
    magazine {
      id
      title
      language
      abbreviation
    }
    edition {
      id
      year
      volume
      edition_version
      title
    }
  }
`

/**
 * Extended edition reference fields Contains additional fields needed for
 * detailed edition information
 */
export const ARTICLE_EXTENDED_EDITION_FIELDS = gql`
  fragment ArticleExtendedEditionFields on Article {
    edition {
      id
      edition_version
      title
      volume
      year
    }
  }
`

/**
 * Extended magazine reference fields Contains additional fields needed for
 * detailed magazine information
 */
export const ARTICLE_EXTENDED_MAGAZINE_FIELDS = gql`
  fragment ArticleExtendedMagazineFields on Article {
    magazine {
      id
      title
      language
      slug
      abbreviation
      selectionAndEssence
    }
  }
`

/** Article footnotes fragment Contains the footnote fields */
export const ARTICLE_FOOTNOTES_FIELDS = gql`
  fragment ArticleFootnotesFields on Article {
    footnotes {
      footnoteType
      content
      id
    }
  }
`

/**
 * Complete article fields for detailed views Includes all article data
 * including references and authors
 */
export const ARTICLE_COMPLETE_FIELDS = gql`
  ${ARTICLE_WITH_AUTHORS_FIELDS}
  ${ARTICLE_REFERENCE_FIELDS}
  ${ARTICLE_FOOTNOTES_FIELDS}
  fragment ArticleCompleteFields on Article {
    ...ArticleWithAuthorsFields
    ...ArticleReferenceFields
    ...ArticleFootnotesFields
    pdf
  }
`
